import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle, Star, ShieldCheck, Download, Users, BookOpen, Gift, ArrowRight, Check, Clock } from 'lucide-react';
import { Button } from './components/ui/Button';
import { CtaButton } from './components/ui/CtaButton';
import { Countdown } from './components/ui/Countdown';
import { Testimonials } from './components/Testimonials';
import { TableroDetails } from './components/TableroDetails';
import { FAQ } from './components/FAQ';
import { CostOfInaction } from './components/CostOfInaction';
import { MetaPixel, trackPixel } from './components/MetaPixel';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/esg6LUXakFFA3Pv8K5C7sC/mockup_pack_anti_pantalla.png';
const CHECKOUT_BASICO = 'https://www.impulsolab.store/cart/66925404684333:1';
const CHECKOUT_PREMIUM = 'https://www.impulsolab.store/cart/66925409173549:1';
export function App() {
  return <div className="min-h-screen bg-zinc-950 text-zinc-100 selection:bg-cyan-500/30" data-id="element-0">
      <MetaPixel data-id="element-1" />
      {/* Top Banner */}
      <div className="bg-cyan-500 text-zinc-950 py-2 px-4 text-center text-sm font-bold tracking-wide" data-id="element-2">
        🚀 IMPULSO LAB™ | Todo el entretenimiento de tu hijo. Listo. Desde hoy.
      </div>

      {/* Hero Section */}
      <section className="relative pt-10 pb-16 px-4 overflow-hidden" data-id="element-3">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-cyan-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-4" />

        <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-5">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-zinc-900 border border-zinc-800 text-zinc-300 text-xs mb-6" data-id="element-6">
            <span className="flex h-2 w-2 rounded-full bg-cyan-500 animate-pulse" data-id="element-7" />
            El sistema N°1 para mamás que quieren reducir pantallas
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-4xl font-extrabold tracking-tight mb-4 leading-tight" data-id="element-8">
            IMPULSO LAB <br data-id="element-9" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500" data-id="element-10">
              MegaPack Anti-Pantallas
            </span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="text-base md:text-lg text-zinc-400 max-w-2xl mx-auto mb-8 leading-relaxed" data-id="element-11">
            Actividades + rutinas + planificación + gamificación listas para
            usar.{' '}
            <strong className="text-zinc-200 font-semibold" data-id="element-12">
              Sin improvisar. Sin inventar cada día. Sin pelear por el celular.
            </strong>
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.3
        }} className="relative max-w-[260px] mx-auto mb-8" data-id="element-13">
            <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-transparent to-transparent z-10 h-full w-full" data-id="element-14" />
            <img src={PRODUCT_IMAGE} alt="MegaPack Anti-Pantallas" className="w-full h-auto drop-shadow-[0_0_40px_rgba(6,182,212,0.3)] relative z-0" data-id="element-15" />
          </motion.div>

          <div className="flex flex-wrap justify-center gap-3 md:gap-6 mb-8 text-xs md:text-sm font-medium text-zinc-300" data-id="element-16">
            <div className="flex items-center gap-2" data-id="element-17">
              <Download className="w-4 h-4 text-cyan-400" data-id="element-18" /> 100% PDF
            </div>
            <div className="flex items-center gap-2" data-id="element-19">
              <Clock className="w-4 h-4 text-cyan-400" data-id="element-20" /> Acceso en 5 min
            </div>
            <div className="flex items-center gap-2" data-id="element-21">
              <Users className="w-4 h-4 text-cyan-400" data-id="element-22" /> Niños de 3 a 10 años
            </div>
          </div>

          <Button size="lg" className="w-full md:w-auto mb-6" onClick={() => document.getElementById('ofertas')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-23">
            QUIERO MI MEGAPACK AHORA <ArrowRight className="ml-2 w-5 h-5" data-id="element-24" />
          </Button>

          <div className="flex justify-center items-center gap-6 text-xs text-zinc-500" data-id="element-25">
            <span className="flex items-center gap-1" data-id="element-26">
              <ShieldCheck className="w-4 h-4" data-id="element-27" /> Garantía 7 días
            </span>
            <span className="flex items-center gap-1" data-id="element-28">
              <CheckCircle2 className="w-4 h-4" data-id="element-29" /> Pago seguro
            </span>
          </div>
        </div>
      </section>

      {/* Stats Bar */}
      <section className="border-y border-zinc-900 bg-zinc-900/30 py-8" data-id="element-30">
        <div className="max-w-5xl mx-auto px-4 grid grid-cols-2 md:grid-cols-4 gap-8 text-center divide-x divide-zinc-800" data-id="element-31">
          <div data-id="element-32">
            <div className="text-3xl font-bold text-white mb-1" data-id="element-33">+500</div>
            <div className="text-sm text-zinc-400 uppercase tracking-wide" data-id="element-34">
              Mamás confían
            </div>
          </div>
          <div data-id="element-35">
            <div className="text-3xl font-bold text-white mb-1" data-id="element-36">6</div>
            <div className="text-sm text-zinc-400 uppercase tracking-wide" data-id="element-37">
              Tomos listos
            </div>
          </div>
          <div data-id="element-38">
            <div className="text-3xl font-bold text-white mb-1" data-id="element-39">6</div>
            <div className="text-sm text-zinc-400 uppercase tracking-wide" data-id="element-40">
              Bonos incluidos
            </div>
          </div>
          <div data-id="element-41">
            <div className="text-3xl font-bold text-white mb-1 flex items-center justify-center gap-1" data-id="element-42">
              4.9/5 <Star className="w-5 h-5 text-yellow-400 fill-yellow-400" data-id="element-43" />
            </div>
            <div className="text-sm text-zinc-400 uppercase tracking-wide" data-id="element-44">
              Calificación
            </div>
          </div>
        </div>
      </section>

      <Testimonials data-id="element-45" />

      {/* Problem Agitation */}
      <section className="py-16 px-4 bg-zinc-950" data-id="element-46">
        <div className="max-w-4xl mx-auto" data-id="element-47">
          <div className="text-center mb-10" data-id="element-48">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-49">
              ¿Cuántas veces más vas a ceder el celular con culpa?
            </h2>
            <p className="text-lg text-zinc-400" data-id="element-50">
              No es falta de amor.{' '}
              <strong className="text-cyan-400 font-semibold" data-id="element-51">
                Es falta de un sistema.
              </strong>
            </p>
          </div>

          <div className="bg-zinc-900/50 border border-zinc-800 rounded-2xl p-6 md:p-8 grid md:grid-cols-2 gap-4" data-id="element-52">
            {['Tu hijo pide el celular cada 5 minutos.', 'Cedés la pantalla con culpa sin tener otra opción.', 'Compraste cosas que duraron 2 días.', 'Los días de lluvia son una pesadilla.'].map((pain, i) => <div key={i} className="flex items-start gap-3" data-id="element-53">
                <XCircle className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-54" />
                <p className="text-zinc-300" data-id="element-55">{pain}</p>
              </div>)}
          </div>

          <div className="mt-10 text-center" data-id="element-56">
            <p className="text-cyan-400 text-xl font-medium mb-6" data-id="element-57">
              ¿Y si este fuera el último día que pasás así?
            </p>
            <CtaButton label="QUIERO LA SOLUCIÓN" data-id="element-58" />
          </div>
        </div>
      </section>

      {/* The Solution / Tomos */}
      <section className="py-16 px-4 bg-zinc-900/20 border-t border-zinc-900 relative" data-id="element-59">
        <div className="max-w-6xl mx-auto" data-id="element-60">
          <div className="text-center mb-10" data-id="element-61">
            <div className="text-cyan-400 font-bold tracking-widest uppercase text-sm mb-4" data-id="element-62">
              La Solución Definitiva
            </div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-63">
              6 Tomos Completos. 400+ páginas.
            </h2>
            <p className="text-xl text-zinc-400" data-id="element-64">
              Imprimís y el niño arranca solo.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-65">
            {[{
            title: 'Desafíos de Lógica',
            desc: '40 actividades en 4 niveles: secuencias, sudoku y acertijos.',
            color: 'bg-blue-500'
          }, {
            title: 'Arte sin Desorden',
            desc: '40 actividades limpias: coloreado, mandalas y proyectos creativos.',
            color: 'bg-purple-500'
          }, {
            title: 'Laberintos Evolutivos',
            desc: '35 laberintos de fácil a experto, con desafíos especiales.',
            color: 'bg-green-500'
          }, {
            title: 'Lectoescritura Jugada',
            desc: "40 actividades: sopas de letras, crucigramas y 'Mi Primer Libro'.",
            color: 'bg-red-500'
          }, {
            title: 'Naturaleza en Casa',
            desc: '40 páginas de ciencia: experimentos y proyectos caseros.',
            color: 'bg-orange-500'
          }, {
            title: 'Misiones Épicas',
            desc: '35 misiones: origami, inventos y el reto de 24hs sin pantallas.',
            color: 'bg-cyan-500'
          }].map((tomo, i) => <div key={i} className="bg-zinc-900 border border-zinc-800 rounded-2xl p-8 hover:border-zinc-700 transition-colors group" data-id="element-66">
                <div className={`w-12 h-12 rounded-xl ${tomo.color} bg-opacity-20 flex items-center justify-center mb-6`} data-id="element-67">
                  <BookOpen className={`w-6 h-6 ${tomo.color.replace('bg-', 'text-')}`} data-id="element-68" />
                </div>
                <div className="text-zinc-500 text-sm font-bold mb-2 uppercase tracking-wider" data-id="element-69">
                  Tomo {i + 1}
                </div>
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-70">
                  {tomo.title}
                </h3>
                <p className="text-zinc-400 leading-relaxed" data-id="element-71">{tomo.desc}</p>
              </div>)}
          </div>

          <div className="mt-12 bg-zinc-900/50 border border-zinc-800 rounded-2xl p-8 flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-72">
            <div className="space-y-4" data-id="element-73">
              <h4 className="text-xl font-bold text-white" data-id="element-74">
                Cada tomo incluye:
              </h4>
              <ul className="space-y-2" data-id="element-75">
                {['4 niveles de dificultad progresiva', 'Sistema de logros y diplomas', 'Instrucciones claras para no explicar nada', 'Diseñado para imprimir en A4'].map((item, i) => <li key={i} className="flex items-center gap-3 text-zinc-300" data-id="element-76">
                    <CheckCircle2 className="w-5 h-5 text-cyan-400 shrink-0" data-id="element-77" />
                    {item}
                  </li>)}
              </ul>
            </div>
            <img src={PRODUCT_IMAGE} alt="Pack" className="w-64 h-auto drop-shadow-2xl" data-id="element-78" />
          </div>

          <div className="mt-10 text-center" data-id="element-79">
            <CtaButton label="LO QUIERO PARA MI HIJO" data-id="element-80" />
          </div>
        </div>
      </section>

      {/* Bonuses */}
      <section className="py-16 px-4 bg-zinc-950" data-id="element-81">
        <div className="max-w-5xl mx-auto" data-id="element-82">
          <div className="text-center mb-10" data-id="element-83">
            <div className="inline-flex items-center gap-2 bg-yellow-500/10 text-yellow-400 px-4 py-1.5 rounded-full text-sm font-bold mb-4 border border-yellow-500/20" data-id="element-84">
              <Gift className="w-4 h-4" data-id="element-85" /> SIEMPRE INCLUIDOS
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-3" data-id="element-86">
              6 Bonos Estratégicos
            </h2>
            <p className="text-lg text-zinc-400" data-id="element-87">
              Para que el sistema funcione desde el día 1.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-88">
            {[{
            title: 'Plan de Rescate 7 Días',
            desc: 'El plan paso a paso para empezar sin improvisar.',
            value: '$15.000'
          }, {
            title: 'Kit de Inicio Rápido',
            desc: "Setup en 10 minutos. Sistema 'agarro y uso'.",
            value: '$12.000'
          }, {
            title: '30 Frases Mágicas',
            desc: 'Las palabras exactas para cortar el celular sin peleas.',
            value: '$10.000'
          }, {
            title: 'Rutina Express 30 Min',
            desc: 'La fórmula 5-20-5 para bloques reales de calma.',
            value: '$12.000'
          }, {
            title: 'Checklist de Emergencia',
            desc: 'Protocolo de 3 minutos para los días de caos.',
            value: '$10.000'
          }, {
            title: 'Menú Semanal',
            desc: '9 menús armados para no preguntarte qué darle hoy.',
            value: '$10.000'
          }].map((bono, i) => <div key={i} className="bg-zinc-900 border border-zinc-800 rounded-2xl p-6 flex gap-4" data-id="element-89">
                <div className="w-12 h-12 rounded-full bg-cyan-500/10 flex items-center justify-center shrink-0 text-cyan-400 font-bold text-xl" data-id="element-90">
                  0{i + 1}
                </div>
                <div data-id="element-91">
                  <h3 className="text-lg font-bold text-white mb-2" data-id="element-92">
                    {bono.title}
                  </h3>
                  <p className="text-zinc-400 text-sm mb-4" data-id="element-93">{bono.desc}</p>
                  <div className="flex items-center gap-2 text-sm" data-id="element-94">
                    <span className="text-zinc-600 line-through" data-id="element-95">
                      {bono.value}
                    </span>
                    <span className="text-cyan-400 font-bold" data-id="element-96">GRATIS</span>
                  </div>
                </div>
              </div>)}
          </div>

          <div className="mt-10 text-center p-6 bg-cyan-500/5 border border-cyan-500/20 rounded-2xl" data-id="element-97">
            <p className="text-xl text-zinc-300 mb-6" data-id="element-98">
              Valor total bonos:{' '}
              <span className="line-through text-zinc-500" data-id="element-99">$69.000</span>{' '}
              <strong className="text-cyan-400" data-id="element-100">GRATIS con tu MegaPack</strong>
            </p>
            <CtaButton label="QUIERO TODO ESTO GRATIS" data-id="element-101" />
          </div>
        </div>
      </section>

      {/* Pricing */}
      <section id="ofertas" className="py-16 px-4 bg-zinc-900/30 border-y border-zinc-900 scroll-mt-4" data-id="element-102">
        <div className="max-w-5xl mx-auto" data-id="element-103">
          <div className="text-center mb-12" data-id="element-104">
            <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-105">
              Elegí tu MegaPack
            </h2>
            <Countdown data-id="element-106" />
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-107">
            {/* Standard */}
            <div className="bg-zinc-900 border border-zinc-800 rounded-3xl p-8 flex flex-col" data-id="element-108">
              <h3 className="text-2xl font-bold text-white mb-2" data-id="element-109">
                📘 MegaPack Anti-Pantallas
              </h3>
              <p className="text-zinc-400 mb-6 h-12" data-id="element-110">
                Ideal para: empezar hoy y reducir pantallas esta semana.
              </p>

              <div className="mb-8" data-id="element-111">
                <div className="text-zinc-500 line-through text-lg mb-1" data-id="element-112">
                  $49.000 ARS
                </div>
                <div className="text-5xl font-extrabold text-white" data-id="element-113">
                  $19.990{' '}
                  <span className="text-xl text-zinc-500 font-medium" data-id="element-114">ARS</span>
                </div>
              </div>

              <ul className="space-y-4 mb-8 flex-1" data-id="element-115">
                <li className="flex items-start gap-3" data-id="element-116">
                  <Check className="w-5 h-5 text-cyan-400 shrink-0" data-id="element-117" />{' '}
                  <span className="text-zinc-300" data-id="element-118">6 Tomos Completos</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-119">
                  <Check className="w-5 h-5 text-cyan-400 shrink-0" data-id="element-120" />{' '}
                  <span className="text-zinc-300" data-id="element-121">6 Bonos Estratégicos</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-122">
                  <Check className="w-5 h-5 text-cyan-400 shrink-0" data-id="element-123" />{' '}
                  <span className="text-zinc-300" data-id="element-124">
                    240 páginas de actividades
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-125">
                  <Check className="w-5 h-5 text-cyan-400 shrink-0" data-id="element-126" />{' '}
                  <span className="text-zinc-300" data-id="element-127">120 páginas de guías</span>
                </li>
              </ul>

              <Button variant="outline" fullWidth onClick={() => {
              trackPixel('InitiateCheckout', {
                content_name: 'MegaPack Anti-Pantallas',
                value: 19990,
                currency: 'ARS'
              });
              window.location.href = CHECKOUT_BASICO;
            }} data-id="element-128">
                QUIERO MI MEGAPACK
              </Button>
            </div>

            {/* Premium */}
            <div id="oferta-premium" className="bg-zinc-900 border-2 border-cyan-500 rounded-3xl p-8 flex flex-col relative transform md:-translate-y-4 shadow-[0_0_40px_rgba(6,182,212,0.15)] scroll-mt-8" data-id="element-129">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-cyan-500 text-zinc-950 px-4 py-1 rounded-full text-sm font-bold tracking-wide" data-id="element-130">
                MÁS ELEGIDO ⭐
              </div>

              <h3 className="text-2xl font-bold text-white mb-2 flex items-center gap-2" data-id="element-131">
                🏆 MegaPack + Tablero
              </h3>
              <p className="text-zinc-400 mb-6 h-12" data-id="element-132">
                Ideal para: convertir el pack en un hábito de por vida con
                gamificación total.
              </p>

              <div className="mb-8" data-id="element-133">
                <div className="text-zinc-500 line-through text-lg mb-1" data-id="element-134">
                  $69.000 ARS
                </div>
                <div className="text-5xl font-extrabold text-cyan-400" data-id="element-135">
                  $27.990{' '}
                  <span className="text-xl text-zinc-500 font-medium" data-id="element-136">ARS</span>
                </div>
              </div>

              <ul className="space-y-4 mb-8 flex-1" data-id="element-137">
                <li className="flex items-start gap-3" data-id="element-138">
                  <Check className="w-5 h-5 text-cyan-400 shrink-0" data-id="element-139" />{' '}
                  <span className="text-zinc-300" data-id="element-140">
                    Todo lo del MegaPack Básico
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-141">
                  <Check className="w-5 h-5 text-yellow-400 shrink-0" data-id="element-142" />{' '}
                  <span className="text-white font-semibold" data-id="element-143">
                    Tablero de Control Familiar
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-144">
                  <Check className="w-5 h-5 text-yellow-400 shrink-0" data-id="element-145" />{' '}
                  <span className="text-white font-semibold" data-id="element-146">
                    Árbol de Habilidades & Rangos
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-147">
                  <Check className="w-5 h-5 text-yellow-400 shrink-0" data-id="element-148" />{' '}
                  <span className="text-white font-semibold" data-id="element-149">
                    400 páginas totales
                  </span>
                </li>
              </ul>

              <Button variant="primary" fullWidth onClick={() => {
              trackPixel('InitiateCheckout', {
                content_name: 'MegaPack + Tablero Premium',
                value: 27990,
                currency: 'ARS'
              });
              window.location.href = CHECKOUT_PREMIUM;
            }} data-id="element-150">
                QUIERO EL MEGAPACK + TABLERO
              </Button>
            </div>
          </div>
        </div>
      </section>

      <TableroDetails data-id="element-151" />
      <FAQ data-id="element-152" />
      <CostOfInaction data-id="element-153" />

      {/* Final CTA */}
      <section className="py-16 px-4 bg-zinc-950 text-center" data-id="element-154">
        <div className="max-w-3xl mx-auto" data-id="element-155">
          <Countdown data-id="element-156" />
          <Button size="xl" className="w-full md:w-auto mt-8 mb-8" onClick={() => document.getElementById('ofertas')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-157">
            QUIERO MI MEGAPACK AHORA <ArrowRight className="ml-2 w-6 h-6" data-id="element-158" />
          </Button>
          <div className="flex flex-wrap justify-center items-center gap-6 text-sm text-zinc-400" data-id="element-159">
            <span className="flex items-center gap-2" data-id="element-160">
              <ShieldCheck className="w-4 h-4 text-cyan-400" data-id="element-161" /> Garantía 7 días
            </span>
            <span className="flex items-center gap-2" data-id="element-162">
              <CheckCircle2 className="w-4 h-4 text-cyan-400" data-id="element-163" /> Pago 100%
              seguro
            </span>
            <span className="flex items-center gap-2" data-id="element-164">
              <Clock className="w-4 h-4 text-cyan-400" data-id="element-165" /> Acceso en 5 minutos
            </span>
          </div>
        </div>
      </section>

      {/* Footer / Guarantee */}
      <footer className="py-16 px-4 bg-zinc-950 text-center border-t border-zinc-900" data-id="element-166">
        <div className="max-w-3xl mx-auto" data-id="element-167">
          <div className="flex justify-center mb-8" data-id="element-168">
            <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-8 max-w-md" data-id="element-169">
              <ShieldCheck className="w-12 h-12 text-cyan-400 mx-auto mb-4" data-id="element-170" />
              <h4 className="text-xl font-bold text-white mb-2" data-id="element-171">
                Garantía 7 Días
              </h4>
              <p className="text-zinc-400 text-sm" data-id="element-172">
                Imprimís el pack. Lo usás. Si en 7 días no es lo que esperabas,
                devolución del 100% sin preguntas.
              </p>
            </div>
          </div>

          <div className="text-zinc-600 text-sm space-y-2" data-id="element-173">
            <p data-id="element-174">🩵 IMPULSO LAB™ — El sistema N°1 para mamás.</p>
            <p data-id="element-175">📧 impulsolab.digital@gmail.com | 🌐 www.impulsolab.store</p>
            <p data-id="element-176">© Impulso Lab™ 2026 — Todos los derechos reservados.</p>
          </div>
        </div>
      </footer>
    </div>;
}